import pic1 from "./BuckinghamPictures/Photo-01 (2).webp";
import pic2 from "./BuckinghamPictures/Photo-02 (2).webp";

export const ActivistPhotoContent = [
  {
    id: 1,
    title: "Photos",
    latestPicture: {
      image: pic1,
      date: "19 October 2024",
      time: "7:32pm",
      location: "Buckingham Palace",
    },
    pictures: [
      {
        image: pic1,
        date: "19 October 2024",
        time: "7:32pm",
        location: "Buckingham Palace",
      },
      {
        image: pic2,
        date: "19 October 2024",
        time: "7:33pm",
        location: "Buckingham Palace",
      },
    ],
  },
];
